import React, { Component } from 'react'
import Hotel from './HotelView/HoteView.container'
import LinkDropdown from '../../../components/Buttons/linkDropdown'
import Button from '../../../components/Buttons'
import PaginationButtons from '../../../containers/Sections/Propiedades/pagination'
import { DropdownButton, MenuItem }from 'react-bootstrap'
import { Link } from 'react-router'
import { translate } from "react-translate"
import Scroll from'react-scroll';


const options = [{id: "max_area" , name:  "Mayor M2"},{id: "min_area" , name:  "Menor M2"}, {id: "min_rating" , name:  "Estrellas ASC"} , {id: "max_rating" , name:  "Estrellas DESC"}, {id: "min_rooms" , name:  "Cant. Habitaciones ASC"}, {id: "max_rooms" , name:  "Cant. Habitaciones DESC"}, {id: "min_city" , name:  "Ciudad ASC"}, {id: "max_city" , name:  "Ciudad DESC"}]

@translate("ActionBar")
export default class HotelesList extends Component {
  render () {

    const {
      onChangeOrder,
      hotels,
      order,
      t
    } = this.props;

    let order_title = order ? order.name : `${t("Ordenar_Por")}`

    var Element = Scroll.Element;
    return (
        <div className="container">
          <div className="ordenar-drop">
            <DropdownButton title={order_title} id="dropdown-order" onSelect={ onChangeOrder }>
              {options.map((item, index) =>
                <MenuItem className="div-option" eventKey={item} key={index}>{item.name}</MenuItem>
              )}
            </DropdownButton>
          </div>
          <div className="hotels-divisor hidden-xs">
          </div>
          <Element name="ContainerPropiedades">
            <div className="hotels-list">
              {hotels.map((item, index) =>
                <Link to={'/' + item.uri || item.property_code} key={index}>
                  <Hotel hotel={item} key={index}/>
                </Link>
              )}
            </div>
          </Element>
          <PaginationButtons />
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageHotels/components/HotelList.component.js